import React from 'react';
import Modal from 'react-modal';
import styles from '../../../assets/css/modalComponent.module.css';

Modal.setAppElement('#root');

const ModalComponent = ({ isOpen, onClose, onConfirm, title, children, className, overlayClassName, hideFooter  }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      className={className || styles.modalWrapper}       // usa la clase pasada o default
      overlayClassName={overlayClassName || styles.modalOverlay} // idem
    >
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h5 className={styles.modalTitle}>{title}</h5>
          <button type="button" className={styles.btnClose} onClick={onClose}>&times;</button>
        </div>
        <div className={styles.modalBody}>
          {children}
        </div>
        {!hideFooter && (
          <div className={styles.modalFooter}>
            <button className={`btn btn-secondary ${styles.button}`} onClick={onClose}>
              Cancelar
            </button>
            <button className={`btn btn-primary ${styles.button}`} onClick={onConfirm}>
              {title === 'EDITAR REGISTRO'? 'ACTUALIZAR': 'ACEPTAR'}
            </button>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ModalComponent;
